import { c as _c } from "react/compiler-runtime";
import { Link, type LinkProps } from '@/components/links';
import { mergeClasses } from '@/utils/style';
import ChevronDown from '@/assets/icons/heroIcons/Chevron-down.svg';
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FOOTER_TEST_ID } from '@/sections/layout/Footer/index';
import { uppercaseFirstLetter } from '@/utils/string';
interface LinkItem {
  title: string;
  to: string;
  id: string;
  target?: LinkProps['target'];
}
interface LinkListProps {
  title: string;
  links: LinkItem[];
  onRow?: boolean;
  isAccordion?: boolean;
}
interface ContentProps {
  links: LinkItem[];
  onRow?: boolean;
}
function Content(t0) {
  const $ = _c(7);
  const {
    links,
    onRow
  } = t0;
  const t1 = onRow ? "flex-row flex-wrap" : "flex-col lg:gap-1";
  let t2;
  if ($[0] !== t1) {
    t2 = mergeClasses("flex gap-3", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== links) {
    t3 = links.map(_temp);
    $[2] = links;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(link) {
  return <Link key={link.id} to={link.to} analyticsParam={`${FOOTER_TEST_ID}${uppercaseFirstLetter(link.id)}`} testId={`${FOOTER_TEST_ID}${uppercaseFirstLetter(link.id)}`} className="!text-sm text-white no-underline hover:text-white hover:underline" target={link.target}>{link.title}</Link>;
}
function LinkCategory(t0) {
  const $ = _c(32);
  const {
    isAccordion,
    links,
    onRow,
    title
  } = t0;
  const [expanded, setExpanded] = useState(false);
  if (isAccordion) {
    let t1;
    if ($[0] !== expanded) {
      t1 = () => setExpanded(!expanded);
      $[0] = expanded;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== title) {
      t2 = <span className="text-base font-semibold text-white lg:text-xl">{title}</span>;
      $[2] = title;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const t3 = expanded ? "rotate-180" : "rotate-0";
    let t4;
    if ($[4] !== t3) {
      t4 = mergeClasses("inline-block text-white transition-transform", t3);
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <ChevronDown />;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== t4) {
      t6 = <span className={t4}>{t5}</span>;
      $[7] = t4;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t2 || $[10] !== t6) {
      t7 = <span className="mb-3 flex cursor-pointer items-center justify-between">{t2}{t6}</span>;
      $[9] = t2;
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== t1 || $[13] !== t7) {
      t8 = <motion.header initial={false} onClick={t1}>{t7}</motion.header>;
      $[12] = t1;
      $[13] = t7;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== expanded || $[16] !== links || $[17] !== onRow) {
      t9 = expanded && <motion.section key="content" initial="collapsed" animate="open" exit="collapsed" variants={{
        open: {
          opacity: 1,
          height: "auto"
        },
        collapsed: {
          opacity: 0,
          height: 0
        }
      }} transition={{
        duration: 0.4,
        ease: [0.04, 0.62, 0.23, 0.98]
      }}><div className="pb-6"><Content links={links} onRow={onRow} /></div></motion.section>;
      $[15] = expanded;
      $[16] = links;
      $[17] = onRow;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== t9) {
      t10 = <AnimatePresence initial={false}>{t9}</AnimatePresence>;
      $[19] = t9;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== t10 || $[22] !== t8) {
      t11 = <div>{t8}{t10}</div>;
      $[21] = t10;
      $[22] = t8;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    return t11;
  }
  let t1;
  if ($[24] !== title) {
    t1 = <p className="mb-3 text-xl font-semibold text-white">{title}</p>;
    $[24] = title;
    $[25] = t1;
  } else {
    t1 = $[25];
  }
  let t2;
  if ($[26] !== links || $[27] !== onRow) {
    t2 = <Content links={links} onRow={onRow} />;
    $[26] = links;
    $[27] = onRow;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  let t3;
  if ($[29] !== t1 || $[30] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  return t3;
}
export default LinkCategory;